module.exports = __webpack_public_path__ + "img/wifi.4b425aa3.svg";